import { render } from "./VInput.vue?vue&type=template&id=bdc28b40"
import script from "./VInput.vue?vue&type=script&lang=ts"
export * from "./VInput.vue?vue&type=script&lang=ts"

const cssModules = script.__cssModules = {}
import style0 from "./VInput.vue?vue&type=style&index=0&id=bdc28b40&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script